import React, {useEffect} from "react";
import PageTitle from "../components/PageTitle";
import { useAtom } from "jotai";
import { authAtom } from "../states/auth";
// import AlertCustom from "../components/AlertCustom/AlertCustom";

const Dashboard = () => {

	const [auth, setAuth] = useAtom(authAtom);
	console.log("DASHBOARD LOADED",auth);
	useEffect(() => {
		if (auth?.user) {
		  console.log("User data from auth atom:", auth);
		} else {
		  console.log("No user data found in auth atom");
		}
	  }, [auth]);

	

	return (
		<>
			<PageTitle title="Dashboard" />
			{/* <AlertCustom title="Main title goes here..."  message="This is for supporting text" variant="primary" /> */}
		</>
	);
};

export default Dashboard;
